/* eslint-disable *//* eslint-disable arrow-parens */
import React, { useCallback, useRef, useEffect, useState } from "react";
import { AgGridColumn, AgGridReact } from "ag-grid-react";
import { CellValueChangedEvent, ColumnApi, GridReadyEvent, GridApi, ICellRendererParams } from "ag-grid-community";
import { CoveredDependentsProps } from "../../../../types/components/coveredDependents.types";
import { Checkbox } from "@mui/material";
import { useContext } from "react";
import { ThemeContext } from "../../../../contexts";
import { useHistory } from "react-router-dom";

import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

import "./coveredDependents.css";
import { Grid } from "@mui/material";
import { Button } from "@mui/material";
import { Member } from "../../../../types/employee.types";
import { api } from "../../../../utils/api";
import ExistsEnrollmentModel from "../../existsMemberModel/ExistsEnrollmentModel";

const CoveredDependents = ({ dependents, handleSelectDependent, selectedDependents }: CoveredDependentsProps): JSX.Element => {
	const [gridHeight, setGridHeight] = useState("300px");
	const agGridRef = useRef<any>(null);

	const [agGridAPI, setAgGridAPI] = useState<GridApi | null>(null);
	const [agGridColumnAPI, setAgGridColumnAPI] = useState<ColumnApi | null>(null);
	const { theme } = useContext(ThemeContext);
	const history = useHistory();

	const selectedDependentsRef = useRef(selectedDependents);
	selectedDependentsRef.current = selectedDependents;
	const handleSelectDependentRef = useRef(handleSelectDependent);
	handleSelectDependentRef.current = handleSelectDependent;

	const handleAgGridReady = (params: GridReadyEvent) => {
		const { api, columnApi } = params;
		setAgGridAPI(api);
		setAgGridColumnAPI(columnApi);
		api.sizeColumnsToFit();
	};

	// console.log("Dependentchecksss->>>>>", dependents);

	const _handleSelectDependent = useCallback(
		async (event: React.ChangeEvent<HTMLInputElement>) => {
			let member: Member;
			if (dependents.length === 1) {
				member = dependents[0];
			} else {
				const focusedCell = agGridRef.current.api.getFocusedCell();
				const row = agGridRef.current.api.getDisplayedRowAtIndex(focusedCell?.rowIndex);
				member = row?.data;
			}

			handleSelectDependent(event, member);
		},
		[dependents, handleSelectDependent]
	);

	const handleAddDependentClick = useCallback(() => {
		history.push("/home/add-family-member");
	}, [history]);

	// const selectDependentCellRenderer = useCallback(() => {
	// 	return <Checkbox onChange={_handleSelectDependent} />;
	// }, [_handleSelectDependent]);

	const selectDependentCellRenderer = useCallback(
		(params: ICellRendererParams) => {
			const selected = selectedDependentsRef.current;
			if (selected === undefined) {
				return <Checkbox onChange={_handleSelectDependent} />;
			}
			const rowMember = params.data as Member;
			return (
				<Checkbox
					checked={selected.some((d) => d.SSN === rowMember?.SSN)}
					onChange={(event) => handleSelectDependentRef.current(event, rowMember)}
				/>
			);
		},
		[_handleSelectDependent]
	);

	const selectedSSNKey = selectedDependents?.map((d) => d.SSN).join("|");
	useEffect(() => {
		if (selectedSSNKey === undefined || !agGridAPI) return;
		agGridAPI.refreshCells({ force: true, columns: ["select_dependent"] });
	}, [agGridAPI, selectedSSNKey]);

	useEffect(() => {
		switch (dependents.length) {
			case 0: {
				setGridHeight("110px");
				break;
			}
			case 1: {
				setGridHeight("110px");
				break;
			}
			case 2: {
				setGridHeight("160px");
				break;
			}
			case 3: {
				setGridHeight("200px");
				break;
			}
			case 4: {
				setGridHeight("240px");
				break;
			}
			case 5: {
				setGridHeight("290px");
				break;
			}
			case 6: {
				setGridHeight("340px");
				break;
			}
			case 7: {
				setGridHeight("390px");
				break;
			}
		}
	}, [dependents.length]);

	return (
		<>
			<div className="covered-dependents">
				<div className="header-container">
					<div className="theme-plan-header">Covered Dependents</div>
					<div className="theme-plan-sub-header" style={{ borderLeftColor: theme.primary_color }}>
						In addition to yourself, who would you like to cover under this plan?
					</div>
				</div>
				<div className="theme-plan-inner-section-margin" />
				<div className="ag-theme-alpine" style={{ height: gridHeight, width: "100%" }}>
					{dependents.length !== 0 ? (
						<AgGridReact
							ref={agGridRef}
							rowData={dependents}
							onGridReady={handleAgGridReady}
							animateRows
							rowDragManaged
							defaultColGroupDef={{ marryChildren: true }}
							// enableCellChangeFlash={true}
							frameworkComponents={{ selectDependentCellRenderer }}
							onCellValueChanged={(params: CellValueChangedEvent) => {
								params.api.refreshCells({
									force: true,
									columns: ["select_dependent"]
								});
							}}
						>
							<AgGridColumn field="first_name" headerName="First Name"></AgGridColumn>
							<AgGridColumn field="last_name" headerName="Last Name"></AgGridColumn>
							<AgGridColumn field="relationship" headerName="Relationship"></AgGridColumn>
							<AgGridColumn
								colId="select_dependent"
								headerName="Select Dependent"
								cellRenderer="selectDependentCellRenderer"
							></AgGridColumn>
						</AgGridReact>
					) : null}
				</div>
				<div className="theme-plan-inner-section-margin" />
				<Grid container>
					<Grid item xl={7} lg={7} md={7} xs={12} sm={12}>
						<div className="theme-plan-icon-item-container">
							{/* <div>
							<ErrorOutlineIcon className="info-icon" />
						</div>
						<div className="theme-plan-text" style={{ marginTop: 0 }}>
							<a href="#">How do i add dependent that is not listed?</a>
						</div> */}
						</div>
					</Grid>
					<Grid item xl={5} lg={5} md={5} xs={12} sm={12}>
						<div className="grid-actions-container">
							{/* <Button variant="text">Reset</Button> */}
							<div className="grid-action-margin" />
							<Button
								variant="contained"
								className="plan-action-button"
								style={{
									color: theme.button.color,
									backgroundColor: theme.button.background_color
								}}
								onClick={handleAddDependentClick}
							>
								Add Dependent
							</Button>
						</div>
					</Grid>
				</Grid>
			</div>
			{/* {isModelOpen && <ExistsEnrollmentModel onClose={() => setIsModelOpen(false)} />} */}
		</>
	);
};

export default CoveredDependents;
